module.exports = __webpack_public_path__ + "static/media/preloader.72f0f872.gif";